import React from 'react';
import { Parallax } from 'react-parallax';
import { Subtitle, Title } from 'components';
import {
  Wrapper,
  ParallaxWrapper,
  StyledParallax,
  BackgroundImage,
  Overlay,
  ImageWrapper,
  ScreensImage
} from './styles';

export default function SobreTop() {
  return (
    <Wrapper>
      <ParallaxWrapper>
        <StyledParallax
          bgImage={require('assets/banner-sobre.jpg')}
          bgImageAlt=""
          className="desktop"
          strength={400}
        />
        <Overlay>
          <Subtitle>
            O futuro da medicina passa pela prescrição eletrônica.
          </Subtitle>
          <Title>Prescrição eletrônica é Nexodata.</Title>
          <ImageWrapper>
            <ScreensImage
              src={require('assets/sobre-top-screens.png')}
              alt=""
            />
          </ImageWrapper>
        </Overlay>
      </ParallaxWrapper>
      {/* <BackgroundImage
        alt=""
        className="desktop"
        src={require('assets/banner-sobre.jpg')}
      /> */}
      <BackgroundImage
        alt=""
        className="mobile"
        src={require('assets/banner-sobre-mobile.jpg')}
      />
    </Wrapper>
  );
}
